import { Box, Button, Table, Text } from '@factorialco/deprecated-design-system'
import { LedgerAccountFragment } from 'generated/resources/graphql'

import NumberField from 'modules/core/components/NumberField'
import { fromCents, toCents } from 'modules/core/lib/formatCurrencyUtils'

import {
  LedgerAccountSelector,
  formatAccountName,
} from 'modules/banking/components/LedgerAccountSelector'

interface JournalDraftEntryLineRowProps {
  disabled: boolean
  lineId: string
  legalEntityId: string
  onSelectLedgerAccount?: (id: string) => void
  selectedLedgerAccountId?: string
  selectedLedgerAccount?: LedgerAccountFragment
  ledgerAccounts?: LedgerAccountFragment[]
  debitAmountCents: number
  onChangeDebitAmount?: (value: number) => void
  creditAmountCents: number
  onChangeCreditAmount?: (value: number) => void
  onDelete?: () => void
  currency: string
}

export const JournalDraftEntryLineRow = ({
  disabled,
  lineId,
  legalEntityId,
  onSelectLedgerAccount,
  selectedLedgerAccountId,
  selectedLedgerAccount,
  ledgerAccounts,
  debitAmountCents,
  onChangeDebitAmount,
  creditAmountCents,
  onChangeCreditAmount,
  onDelete,
  currency,
}: JournalDraftEntryLineRowProps) => {
  return (
    <Table.Row key={lineId}>
      <Table.Cell padding="s0" style={{ height: '64px' }}>
        <Box paddingLeft="s12">
          <LedgerAccountSelector
            legalEntityId={legalEntityId}
            disabled={disabled}
            onSelect={(id) => {
              onSelectLedgerAccount?.(id)
            }}
            selectedLedgerAccountIdProp={selectedLedgerAccountId}
            currentLedgerAccountName={formatAccountName(selectedLedgerAccount)}
            accounts={ledgerAccounts}
            canManage
          />
        </Box>
      </Table.Cell>
      <Table.Cell padding="s0" width={130} style={{ paddingLeft: '8px' }}>
        <Box height="full">
          <NumberField
            readonly={disabled}
            maxDecimals={2}
            step={0.01}
            min={0}
            indicator={
              <Text.Normal size="200" color="grey600" weight="medium">
                {currency}
              </Text.Normal>
            }
            value={fromCents(debitAmountCents) || null}
            onChange={(value) => {
              onChangeDebitAmount?.(toCents(Math.abs(Number(value))))
            }}
          />
        </Box>
      </Table.Cell>
      <Table.Cell padding="s0" width={130} style={{ paddingLeft: '8px' }}>
        <Box height="full">
          <NumberField
            readonly={disabled}
            maxDecimals={2}
            step={0.01}
            min={0}
            indicator={
              <Text.Normal size="200" color="grey600" weight="medium">
                {currency}
              </Text.Normal>
            }
            value={fromCents(creditAmountCents) || null}
            onChange={(value) => {
              onChangeCreditAmount?.(toCents(Math.abs(Number(value))))
            }}
          />
        </Box>
      </Table.Cell>
      {onDelete && (
        <Table.Cell width={40} padding="s0">
          <Box paddingX="s8" paddingY="s12" alignItems="center">
            <Button
              type="secondary"
              iconName="delete"
              onClick={() => onDelete()}
              aria-label="Delete"
            />
          </Box>
        </Table.Cell>
      )}
    </Table.Row>
  )
}
